/**
 * E7 PR 0b (D134) — what an operation's undo needs from the moment its REQUEST was sent: the identity it was sent as,
 * the signed-in account, and the session's signal. A caller takes it BEFORE the request (`captureUndoContext()`) and
 * hands it to the `record*` call (useUndo): a session that ended while the request was out records nothing, and the
 * undo acts as exactly that identity. Its own subpath (`@papan/core-ui/ui/undoCapture`) so tests that mock the
 * `@papan/core-ui/ui` barrel keep working.
 */
import { captureRequestIdentity, type RequestIdentity } from '@papan/api-client'
import { accountEpoch, sessionSignal } from './sessionEnded'

export interface UndoCapture { identity: RequestIdentity; account: number; signal: AbortSignal }

export function captureUndoContext(): UndoCapture {
  return { identity: captureRequestIdentity(), account: accountEpoch(), signal: sessionSignal() }
}
